// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 2H1V18H23V2ZM13.5859 12.5002L16.0859 10.0002L13.5859 7.50015L15.0001 6.08594L18.9144 10.0002L15.0001 13.9144L13.5859 12.5002ZM9.00015 13.9144L5.08594 10.0002L9.00015 6.08595L10.4144 7.50016L7.91436 10.0002L10.4144 12.5002L9.00015 13.9144Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 20H3V22H21V20Z"}}]};

const SystemCodeFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'system-code-filled',
    ref,
    icon: element,
  },
));

SystemCodeFilledIcon.displayName = 'SystemCodeFilledIcon';

export default SystemCodeFilledIcon;
